import Vue from "vue"
import * as types from '../../store/types'
import {store} from '../../store/store'

const checkPermission = (key) => {
    if(!store.getters[types.CURRENT_USER].permissions)
        throw Error('CURRENT_USER permissions not set')

    return store.getters[types.CURRENT_USER].permissions.find( (perm) => { return perm === key }) 
}

const checkRole = (key) => {

    if(!store.getters[types.CURRENT_USER].roles)
        throw Error('CURRENT_USER roles not set')
    
    let found = store.getters[types.CURRENT_USER].roles.find( (perm) => {
        return perm.name === key 
    }) 
    
    return found ? true : false
}

Vue.prototype.$currentUserHasPermission = (key) => {    
    return checkPermission(key)    
};
Vue.prototype.$currentUserHasRole = (key) => {

    return checkRole(key)
};
